(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["daluca-rally-custom-width"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('daluca-rally-width')){
  const choices=new Map();
  class DaLucaRallyWidth extends HTMLElement{
    connectedCallback(){
      this.form=this.closest('form');
      this.select=this.querySelector('select');
      if(!this.form||!this.select)return;
      const requested=new URLSearchParams(location.search).get('daluca_width');
      const initial=choices.get(this.dataset.product)||(requested?requested+'mm':'');
      if(Array.from(this.select.options).some(option=>option.value===initial))this.select.value=initial;
      this.onChange=event=>{
        if(event.target===this.select)choices.set(this.dataset.product,this.select.value);
        this.sync();
      };
      document.addEventListener('change',this.onChange,true);
      document.addEventListener('product:variant-change',this.onChange);
      this.sync();
    }
    disconnectedCallback(){
      document.removeEventListener('change',this.onChange,true);
      document.removeEventListener('product:variant-change',this.onChange);
    }
    sync(){
      if(!this.form||!this.select)return false;
      const id=this.form.querySelector('[name="id"]');
      const picker=document.getElementById('variant-selects-'+this.dataset.section);
      const fieldset=picker&&picker.querySelectorAll('fieldset')[Number(this.dataset.widthIndex)];
      const field=fieldset&&fieldset.querySelector('select,input:checked');
      const custom=this.dataset.customVariants.split(',').includes(String(id&&id.value))||Boolean(field&&/custom/i.test(field.value));
      this.hidden=!custom;
      this.select.disabled=!custom;
      this.select.required=custom;
      return custom;
    }
    exactWidth(){return this.sync()?/^(?:18|19|20|21|22|23|24|25|26)mm$/.test(this.select.value)?this.select.value:'':'';}
    validate(){
      if(!this.sync())return true;
      if(this.exactWidth())return true;
      this.select.value='';
      this.select.reportValidity();
      this.select.focus();
      return false;
    }
  }
  customElements.define('daluca-rally-width',DaLucaRallyWidth);
  document.addEventListener('submit',event=>{
    const control=event.target.querySelector&&event.target.querySelector('daluca-rally-width');
    if(control&&!control.validate()){event.preventDefault();event.stopImmediatePropagation();}
  },true);
}
  } catch(e) { console.error(e); }
})();

})();
